module.exports = __webpack_public_path__ + "assets/img/news2.4.d816eccb.png";